import { render, staticRenderFns } from "./LittleGateImpacts.vue?vue&type=template&id=6d13a634&scoped=true"
import script from "./LittleGateImpacts.vue?vue&type=script&lang=ts"
export * from "./LittleGateImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d13a634",
  null
  
)

export default component.exports